import useLocalStorageState from 'use-local-storage-state';

export const ENTRY_DRAFTS_STORAGE_KEY = 'entryDrafts';

export function useEntryDraftState() {
  return useLocalStorageState(ENTRY_DRAFTS_STORAGE_KEY);
}
